{
	"title": "Gestisci dichiarazioni",
	"createDeclaration": "Crea dichiarazione"
}
